import MailboxAccountService from '../../../respona_api/generated/mailbox-account_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): MailboxAccountService.MailboxAccountServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new MailboxAccountService.MailboxAccountServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
